import { VideoPlayerButton } from "./VideoPlayerButton.js";
import { VideoPlayerState } from "./VideoPlayerState.js";

export class VideoPlayerPlayButton extends VideoPlayerButton<"playing" | "paused" | "buffering" | "unstarted"> {
    public icons = {
        "playing": "icon-421",
        "paused": "icon-420",
        "buffering": "icon-433",
        "unstarted": "icon-420"
    };

    public create(): void {
        this.iconState = "unstarted";
        this._player.onStateChange.add(this.handleStateChange, this);
    }

    private handleStateChange(state: VideoPlayerState): void {
        if (state === VideoPlayerState.BUFFERING)
            this.iconState = "buffering";
        else if (state === VideoPlayerState.UNSTARTED)
            this.iconState = "unstarted";
        else
            this.iconState = state === VideoPlayerState.PAUSED ? "paused" : "playing";
    }

    protected click(): void {
        var v = this._player.video;
        if (!v || !v.ready)
            return;
        var state = v.state;
        if (state === VideoPlayerState.PLAYING || state === VideoPlayerState.BUFFERING)//Playing
            v.pause();
        else
            v.play();
    }
}